import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {dismissFlowSuccess} from "../../../../widget/misc/WidgetUtils";
import {MerchantButton} from "../../../../common/MerchantButton";
import {HappyFaceIcon} from "../../../../../core/ui/SVGElements.jsx";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {SubscriptionCoveragePerk} from "./components/CoverageDescriptionElements";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {Flow} from "../../../flows/Flow.js";
import {iFrameState} from "../../../../services/IFrameState";
import {PromptManageAccountButton} from "../../../panel-elements/LoginFooter.jsx";


export class SubscribeSuccessPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: "center",
        ...this.themeProps.MERCHANT_TITLE_STYLE,
    };

    @styleRule
    icon = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };

    @styleRule
    message = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(SubscribeSuccessPanelStyle)
export class SubscribeSuccessPanel extends BasePanelPage {
    getGuidelines() {
        if (iFrameState.forceHideWallet) {
            return []
        }

        return [
            <SubscriptionCoveragePerk text={Messages.subscribeThankYouGuideline1}/>,
            <SubscriptionCoveragePerk text={Messages.subscribeThankYouGuideline2}/>,
        ]
    }

    render() {
        const {styleSheet} = this;
        const offer = Flow.subscriptionPlan.selectedValue;
        let textElements;

        if (iFrameMerchantService.isMerchant(TNR_ALIAS)) {
            textElements = [
                <div testId="subscribeModalThankYouTitle" className={styleSheet.title}>
                    {Messages.subscribeThankYouTitle}
                </div>,
                <MessageElement className={styleSheet.message} message={Messages.subscribeThankYouText(offer.coverage.name)}/>,
                <div className={styleSheet.message}>{Messages.tnrSubscribeSuccess}</div>,
                <MessageElement className={styleSheet.message}
                                message={Messages.subscribeAndEditSuccess(iFrameMerchantService.getMerchant().getName())} />
            ];
        } else {
            textElements = [
                <HappyFaceIcon className={styleSheet.icon} size={72} color={styleSheet.themeProps.MERCHANT_TEXT_SECONDARY_COLOR}/>,
                <div testId="subscribeModalThankYouTitle" className={styleSheet.title}>
                    {Messages.subscribeThankYouTitle}
                </div>,
                <div className={styleSheet.message}>{Messages.subscribeThankYouText(offer.coverage.name)}</div>,
            ]
        }

        return [
            textElements,
            this.getGuidelines(),
            <MerchantButton onClick={dismissFlowSuccess} className={styleSheet.actionButton}>
                {Messages.ok}
            </MerchantButton>,
            !iFrameMerchantService.isMerchant(TNR_ALIAS) && <PromptManageAccountButton className={styleSheet.backButton} />,
        ];
    }
}
